import { openWhatsApp, DEFAULT_HELLO } from "../lib/whatsapp";

export default function FloatingWhatsApp() {
    return (
        <button
            type="button"
            onClick={() => openWhatsApp(DEFAULT_HELLO)}
            aria-label="Escribir por WhatsApp"
            data-testid="floating-whatsapp-btn"
            style={{
                position: "fixed",
                right: "24px",
                bottom: "24px",
                zIndex: 9999,
            }}
            className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white flex items-center justify-center shadow-2xl wa-pulse transition-colors"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="-1 -1 26 26"
                fill="currentColor"
                aria-hidden="true"
                style={{ display: "block" }}
            >
                <path d="M19.077 4.928A9.94 9.94 0 0012.012 2C6.486 2 1.989 6.494 1.985 12.018a9.94 9.94 0 001.337 4.998L2 22l5.13-1.345a9.97 9.97 0 004.778 1.218h.004c5.526 0 10.022-4.494 10.026-10.018a9.94 9.94 0 00-2.861-7.927zM12.012 20.18h-.003a8.31 8.31 0 01-4.234-1.158l-.304-.18-3.045.799.812-2.967-.198-.314a8.27 8.27 0 01-1.27-4.412c.002-4.598 3.745-8.34 8.347-8.34 2.228 0 4.323.87 5.898 2.448a8.28 8.28 0 012.443 5.896c-.002 4.598-3.745 8.34-8.346 8.34zm4.578-6.247c-.25-.125-1.486-.733-1.716-.817-.23-.084-.398-.125-.566.125-.167.25-.65.817-.797.984-.146.168-.293.188-.543.063-.25-.125-1.058-.39-2.016-1.245-.745-.665-1.248-1.485-1.395-1.735-.146-.25-.016-.385.11-.51.112-.112.25-.293.376-.439.125-.146.166-.25.25-.418.084-.167.042-.313-.02-.438-.063-.125-.566-1.364-.776-1.867-.205-.49-.412-.424-.566-.432-.146-.007-.314-.009-.481-.009a.93.93 0 00-.67.314c-.231.25-.881.86-.881 2.099 0 1.24.902 2.436 1.028 2.604.125.167 1.776 2.713 4.302 3.804.6.26 1.07.413 1.435.529.604.192 1.153.165 1.587.1.484-.072 1.486-.608 1.696-1.195.21-.586.21-1.089.147-1.194-.063-.105-.23-.168-.48-.293z" />
            </svg>
        </button>
    );
}
